var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('div',{ref:"vidBox",staticClass:"player embed-responsive-item",attrs:{"id":"vidBox"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }